import React from 'react';
import PropTypes from 'prop-types';
import css from './TextArea.module.scss';

const TextArea = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  className = '',
  name,
  rows = 4
}) => {
  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <div className={`${css.textAreaContainer} ${className}`}>
      {label && (
        <label className={css.label}>
          {label}
          {required && <span className={css.required}>*</span>}
        </label>
      )}
      <div className={css.textAreaWrapper}>
        <textarea
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          name={name}
          rows={rows}
          className={`${css.textArea} ${error ? css.error : ''}`}
          data-error={!!error}
        />
      </div>
      {error && <span className={css.errorMessage}>{error}</span>}
    </div>
  );
};

TextArea.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  rows: PropTypes.number
};

export default TextArea;
